import loadable from '@loadable/component';

/* istanbul ignore next */
export const NewbuildingBrokerProfessionalAccessBlockedModalLoadable = loadable(
  () =>
    import('@cian/frontend-newbuilding-broker-callback-component').catch(() => ({
      ProfessionalAccessBlockedModal: () => null,
    })),
  {
    resolveComponent: ({ ProfessionalAccessBlockedModal }) => ProfessionalAccessBlockedModal,
    ssr: false,
  },
);
